import React, { Fragment } from 'react'

import { Breadcrumb } from '../../navigation/Breadcrumb/Breadcrumb'
import { BioBlock } from '../../content/BioBlock/BioBlock'
import { Box } from '../../compositions/Box/Box'

import { Profile as ProfileData } from '@news-mono/web-common'

export interface TheWestProfileProps {
    profile: ProfileData
    profileUrl: string
}

export const TheWestProfile: React.FC<TheWestProfileProps> = (props) => {
    return (
        <Fragment>
            <Breadcrumb
                items={[{ text: 'Profiles' }, { text: props.profile.name }]}
            />
            <Box verticalSpacing="md" hasTopSpacing>
                <BioBlock
                    profile={props.profile}
                    url={props.profileUrl}
                    title={props.profile.name}
                />
            </Box>
        </Fragment>
    )
}
